export interface ComprobadorResponse {
    codigoEPS: string;
    codigoRegimen: string;
}

export const  comprobadorInitialState: ComprobadorResponse = {
    codigoEPS: '',
    codigoRegimen: ''
}